// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-f0ceab4c] {\n  max-height: calc(100vh - 350px) !important;\n}\n.table td[data-v-f0ceab4c] {\n  vertical-align: top !important;\n}\n.note-cell[data-v-f0ceab4c] {\n  max-width: 400px;\n}", ""]);
// Exports
module.exports = exports;
